<!-- 智慧门店 -->
<template>
  <div class="shop">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <div class="shopIntr">
      <h3 class="h3">{{propsCon.title}}</h3>
      <div class="shopCon width">
        <div class="shopInt">
          <div class="shopIntItem" v-for="(item,i) in propsCon.content" :key="i">
            <h4>{{item.title}}</h4>
            <p>{{item.pp}}</p>
          </div>
        </div>
        <div class="shopImg">
          <img :src="propsCon.img" alt srcset />
        </div>
      </div>
    </div>
    <!-- 功能板块 -->
    <div class="gnModel">
      <h3 class="h3">功能板块</h3>
      <div class="gnModelCon width">
        <div
          class="gnModelItem"
          v-for="(item,i) in gnData"
          :key="i"
          @mouseover="show_hide(i)"
          @mouseleave="indexIndex=-1"
        >
          <img :src="item.bgImg" alt srcset />
          <div class="iTitle">{{item.title}}</div>
          <div class="pp" v-show="indexIndex==i?'show':''">{{item.pp}}</div>
        </div>
      </div>
    </div>
    <!-- 系统架构 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img" :wwidth="titleImg.wwidth"></TitleImg>
    <!-- 方案优选 -->
    <div class="gatherPlay">
      <h3 class="h3">方案优势</h3>
      <ListItem :modelList="modelList" class="listModel"></ListItem>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import TitleImg from '../components/TitleImg'
import ListItem from '../components/ListItem'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, TitleImg, ListItem, Footer },
  props: {},
  data() {
    return {
      show: false,
      indexIndex: -1,
      topImg: {
        title: '智慧门店',
        bgImg: require('../assets/images/u2191.jpg'),
        content:
          '以数据化运营方式，为每一个进店顾客提供更专业、更优质的消费体验提升连锁服饰转化率、客单价、复购率',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          {
            title: '吸粉引流',
            pp:
              '通过智慧海报机、智慧迎宾机器人，提升驻足率、进店率以及购买率；',
          },
          {
            title: '客流统计分析',
            pp:
              '智慧摄像头，识别VIP漏斗并跟进；远程巡店和管理，分析客流和购买率；',
          },
          {
            title: '会员互动',
            pp:
              '智慧大屏、智慧云货架，减少人力物力，提升成交和复购率并进行VIP推广；',
          },
          {
            title: '智慧收银/自助下单',
            pp:
              '智慧收银机，有智能推广、自助下单和云货架功能，有效提升客户体验和品牌形象；',
          },
          {
            title: 'RFID盘存识别',
            pp:
              '减少人工、时间成本，大幅提升盘存和找货效率，批量智慧盘存管理；',
          },
          {
            title: '智慧门店大数据分析',
            pp:
              '多维度分析，对其进行分群，掌握门店客流量及高低峰，洞察门店表现。',
          },
        ],
        img: require('../assets/images/u2195.png'),
      },
      gnData: [
        {
          id: 1,
          title: '数据采集',
          pp:
            '通过部署多功能摄像头、具有客户信息采集、定位等，为门店赋予智能感官，掌握客流数据，商品关注度收集，会员数据统计等。',
          bgImg: require('../assets/images/u2209.svg'),
        },
        {
          id: 2,
          title: '远程管理',
          pp:
            '通过手机客户端或电脑客户端进入管理后台，可随时随地查看门店实时视频、门店财务数据、门店销售数据、门店库存数据等',
          bgImg: require('../assets/images/u2212.svg'),
        },
        {
          id: 3,
          title: '分析复购',
          pp:
            '通过客流数据和商品关注度以及线上调研数据分析，清晰定位客户需求，提升店铺热卖展示度，为店铺增加复购',
          bgImg: require('../assets/images/u2213.svg'),
        },
        {
          id: 4,
          title: '吸粉引流',
          pp:
            '线上线下双渠道，活动数据收集分析，通过线上活动引流至线下消费，通过对产品数据分析热推优选产品',
          bgImg: require('../assets/images/u2214.svg'),
        },
        {
          id: 5,
          title: '智慧试衣',
          pp:
            '通过3d试穿和增强现实、虚拟现实技术，将热卖款式通过试穿体验设备展示，通过人像识别，将实际试穿身材作为试穿模特，体验实际试穿效果',
          bgImg: require('../assets/images/u2215.svg'),
        },
        {
          id: 6,
          title: '智慧收银',
          pp:
            '集成多种支付方式，支持手机、平板、移动POS机设备；实时查询，无缝接收线上线下订单服务；订单退款审核后直接退回货款；支持各类线上线下卡券核销',
          bgImg: require('../assets/images/u2216.svg'),
        },
        {
          id: 7,
          title: '快速盘存',
          pp:
            '产品绑定标识RFID，使用手持终端无接触式批量盘存，节省近10倍盘存时间。系统实时统计购销情况，盘存后进行库存校验；完整的出入库数据记录，随时可查；',
          bgImg: require('../assets/images/u2217.svg'),
        },
        {
          id: 8,
          title: '多种渠道',
          pp: '打通线上线下，快速扫码核销，促进门销销售与转化',
          bgImg: require('../assets/images/u2218.svg'),
        },
      ],
      titleImg: {
        title: '系统架构',
        img: require('../assets/images/u2260.png'),
      },
      modelList: [
        {
          title: '经济效益',
          content: [
            '无纸化的操作，减少纸张的开销；',
            '提高仓储作业、发货配送等各操作环节的工作效率',
            '增加库存的准确率，提高货物周转率；',
            '大大节约了人工成本，为企业节省资源；',
            '有效的库存空间利用，降低营运成本；',
          ],
          img: require('../assets/images/u1877.png'),
        },
        {
          title: '管理效益',
          content: [
            '条码识别的正确性高，减少人为的错误；',
            '优化仓库入库、出库、转储及盘点作业流程；',
            '各种当前和历史事务的数据为仓库的所有活动、资源和库存水平提供即时的正确信息；',
            '数据交换接口的连通，增强企业现有应用系统的管理。',
          ],
          img: require('../assets/images/u1881.png'),
        },
        {
          title: '追溯效益',
          content: [
            '为仓库作业全过程提供自动化和全面纪录的途径；',
            '通过条码智能手持终端随时追踪托板及板上货物的当前状态信息和具体流向；',
            '有效的库存管理和控制，减少额外的采购，同时保证库存量满足客户订货或生产计划的需要。',
          ],
          img: require('../assets/images/u1885.png'),
        },
        {
          title: '扩展效益',
          content: ['通过接口集成实现系统间的信息共享。', '节省信息化成本。'],
          img: require('../assets/images/u1889.png'),
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    show_hide(i) {
      this.indexIndex = i
    },
  },
}
</script>

<style lang="less" scoped>
.shopIntr {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .shopCon {
    display: flex;
    justify-content: center;
    align-items: center;
    .shopInt {
      flex: 1;

      .shopIntItem {
        margin-bottom: 20px;
        h4 {
          margin: 0;
          font-size: 16px;
          line-height: 22px;
        }
        p {
          margin: 0;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
    .shopImg {
      flex: 1;
      text-align: center;
      img {
        max-width: 650px;
        max-height: 500px;
      }
    }
  }
}
.gnModel {
  background: url('../assets/images/u2189.jpg') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .gnModelCon {
    display: flex;
    flex-wrap: wrap;
    .gnModelItem {
      position: relative;
      flex: 1;
      margin: 0 5px 10px 5px;
      img {
        display: block;
        width: 350px;
        height: 460px;
      }
      .iTitle {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        border-radius: 4px;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 34px;
        color: #000000;
        background: rgba(255, 255, 255, 0.6);
      }
      .pp {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #ffffff;
        line-height: 24px;
        padding: 0 60px;
        color: #fff;
        background-color: #0078d7;
        box-sizing: border-box;
        border-radius: 4px;
      }
    }
  }
}
.gatherPlay {
  background: url('../assets/images/u1872.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
}
</style>
